import { useEffect, useState } from 'react';

export const useDelayedFlag = (flag: boolean, delayMs = 200): boolean => {
  const [delayedFlag, setDelayedFlag] = useState(false);

  useEffect(() => {
    if (!flag) {
      setDelayedFlag(false);
      return undefined;
    }
    const timer = setTimeout(() => {
      setDelayedFlag(true);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [delayMs, flag]);

  return delayedFlag;
};
